/**
 * Appointment Storage JavaScript
 * Handles URL parameters and session storage for appointments
 */

// URL parameter functions
function getZipCodeFromURL() {
    try {
        const urlParams = new URLSearchParams(window.location.search);
        const zipParam = urlParams.get('zip');

        if (zipParam && isValidZipFormat(zipParam)) {
            return zipParam;
        }

        return null;
    } catch (error) {
        return null;
    }
}

function updateURLWithZipCode(zipCode) {
    try {
        const url = new URL(window.location);
        url.searchParams.set('zip', zipCode);

        // Update URL without reloading the page
        window.history.replaceState({}, '', url);
    } catch (error) {
        // Silent error handling
    }
}

// Session storage functions - now provided by appointment-session-storage.js
// These functions are available globally for backward compatibility
